import { AEMScenes } from '@as-react/common-types';

/**
 * Bootstrap function to create and append the bootstrap root element to the document body.
 * This element is used as a placeholder for rendering the Bootstrap component.
 * Do note that this function does not render the component itself; it only sets up the DOM element.
 * The actual rendering is handled elsewhere in the application.
 * And will only be rendered on the client side.
 */
export const bootstrap = () => {
  const bootstrapRoot = document.createElement('div');
  bootstrapRoot.dataset.hypernovaKey = AEMScenes.BOOTSTRAP;
  bootstrapRoot.dataset.hypernovaId = 'bootstrap-component';

  document.body.prepend(bootstrapRoot);
};
